import { useState } from 'react'

import { T, useI18n } from '@tribeplatform/react-components/i18n'
import { Button } from '@tribeplatform/react-ui-kit/Button'
import { FormControl } from '@tribeplatform/react-ui-kit/FormControl'
import { Modal } from '@tribeplatform/react-ui-kit/Modal'
import { RadioGroup } from '@tribeplatform/react-ui-kit/RadioGroup'

export interface ExportWizardModalProps<T> {
  open: boolean
  onClose: () => void
  title: string
  description?: string
  onExport: (fields: T) => Promise<void>
  selectedFields: T
  allFields: T
}

export const ExportWizardModal = <T = unknown,>(
  props: ExportWizardModalProps<T>,
) => {
  const {
    open,
    onClose,
    title,
    description,
    onExport,
    selectedFields,
    allFields,
  } = props
  const { $t } = useI18n()
  const [fields, setFields] = useState<string>('visible')

  return (
    <Modal open={open} onClose={onClose}>
      <Modal.Header title={title} description={description} />
      <Modal.Content>
        <FormControl.RadioGroup
          name="fields"
          value={fields}
          onChange={setFields}
        >
          <RadioGroup.Items>
            <RadioGroup.Item
              value="visible"
              title={$t({
                defaultMessage: 'Export with currently displayed fields',
                id: 'Admin.Members.ExportWithCurrentFields',
              })}
            />
            <RadioGroup.Item
              value="all"
              title={$t({
                defaultMessage: 'Export with all fields',
                id: 'Admin.Members.ExportWithAllField',
              })}
            />
          </RadioGroup.Items>
        </FormControl.RadioGroup>
      </Modal.Content>
      <Modal.Actions>
        <Button
          variant="primary"
          onClick={() =>
            onExport(fields === 'all' ? allFields : selectedFields).then(() =>
              onClose(),
            )
          }
        >
          <T defaultMessage="Export" id="Generics.Export" />
        </Button>
        <Button variant="secondaryNeutral" onClick={onClose}>
          <T defaultMessage="Cancel" id="Generics.Cancel" />
        </Button>
      </Modal.Actions>
    </Modal>
  )
}
